import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import CustModal from '../../../HOC/CustModal';
import Pare from '../../../HOC/ProgressNote/Pare';
import { postRequest, Url } from '../CustomHttp';
import { getSession } from '../Session';
import { dischargeSummaryCommonChild_0, dischargeSummaryCommonChild_1, dischargeSummeryDidWellWith, dischargeSummeryStruggledWith } from './AdditionalJson/AdditionaJson';
import { dischargeSummeryData } from './dischargeSummaryJson';
import { userData } from './ViewDetail';
import Loader from 'react-loader-spinner';
import moment from 'moment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField'
import $ from "jquery";
import '../../components/customPractice/CustomPracticeHeaderFields.css';
import {
    resolveDocumentSignatures,
    buildSignatureParagraphHtml,
    formatSignatureLine,
    resolveSignOffButtonState,
    isDocumentContentEditable,
    isDocumentViewOnlyInEditor,
    resolveDocumentEditorAccess,
    buildStoreClientDocumentViewEditFlag,
    isClinicianFinalSignOnly,
    getSignOffButtonLabel,
    getSignOffConfirmPrompt,
    normalizeDocumentSignStatus,
    stripEmbeddedSignaturesFromHtml,
    resolveDocumentCreatedBy,
    resolveDocumentSignStatusesFromApi,
} from '../../utils/customPractice';

function DischargeSummary(props) {
    let checkSigned = 0;
    let supervisorSigned = 0;
    let showSigned = 0;

    const { userInfo, changePage, editId } = useContext(userData);

    const [commonData, setCommonData] = useState({
        date_of_service: new Date(),
        showError: false,
        count: 0,
    });
    const [Statement, setStatement] = useState('');
    const [viewEdit, setViewEdit] = useState({ confirmChange: false, diagnosis: userInfo.client_diagnosis ?? [], changeId: false, showModal: false, client_document_id: 0, confirmSave: false, editData: false, viewStatement: false, editBy: '', editTime: '', signed_at: '', signed: 1, supervisorSigned: 1, is_updated: 0, created_by: 0, supervisor_signed_by: 0, supervisor_signature: '', supervisor_signed_at: '', status_updated_by_role: '' });
    const [Data, setData] = useState('');
    const [SignOff, setSignOff] = useState({ signOff: false, signOffConfirm: false, signed: 1, supervisor_signed: 1 });
    const [payloadData, setPayloadData] = useState()
    const [selectAllData, setSelectAllData] = useState({})
    const [sentenceLoader, setSentenceLoader] = useState(false)
    const [checkboxLoader, setCheckboxLoader] = useState(false)
    const [loading, setLoading] = useState(false)
    const [documentMetaLoaded, setDocumentMetaLoaded] = useState(!(editId > 0))
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const [formJson, setFormJson] = useState(() =>
        JSON.parse(JSON.stringify(dischargeSummeryData))
    );
    const URL = '/discharge-summary-sentence-builder';

    const handleFormSelectionChange = useCallback((selection) => {
        setPayloadData((prev) => ({
            ...(prev && typeof prev === 'object' ? prev : {}),
            ...selection,
        }));
    }, []);

    const handleFrontJsonPersisted = useCallback((frontJson, documentId) => {
        const session = getSession('userData') || {};
        setViewEdit((prev) => ({
            ...prev,
            client_document_id: documentId || prev.client_document_id,
            created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
        }));
        setSelectAllData(frontJson);
        setPayloadData((prev) => ({
            ...(prev && typeof prev === 'object' ? prev : {}),
            ...frontJson,
            client_document_id: documentId || prev?.client_document_id,
        }));
    }, []);

    const saveStatement = async () => {
        const session = getSession('userData') || {};
        if (
            isDocumentViewOnlyInEditor({
                editId,
                documentMetaLoaded,
                signed: viewEdit.signed,
                supervisorSigned: viewEdit.supervisorSigned,
                userRoleSlug: userInfo.user_role_slug,
                userId: session.id,
                clientCreatorId: userInfo.creator_id,
            })
        ) {
            return;
        }
        const viewEditFlag = buildStoreClientDocumentViewEditFlag(viewEdit.confirmChange);
        const savePayload = {
            ...Data,
            client_document_id: viewEdit.client_document_id,
            view_edit_flag: viewEditFlag,
        };
        const postData = await postRequest("/store-client-document", { Statement, data: savePayload, 'document_type': 'discharge_summary', 'client_id': userInfo.id, client_document_id: editId ?? viewEdit.client_document_id }, true);
        if (postData) {
            setViewEdit((prev) => ({
                ...prev,
                client_document_id: postData.client_document_id,
                confirmSave: true,
                confirmChange: prev.confirmChange || Boolean(viewEditFlag),
                created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
            }));
        }
    }

    const signOffFun = async () => {
        const postData = await postRequest("/client-document-update-status", { client_document_id: viewEdit.client_document_id, 'document_type': 'discharge_summary', 'client_id': userInfo.id, signed: SignOff.signed, supervisor_signed: SignOff.supervisor_signed}, true);
        if (postData) {
            changePage({ id: 6 })
        }
    }

    const setEditableCheckBox = async () => {
        const postData = await postRequest("/client-document-info", { client_document_id: editId }, true);
        if (!isMountedRef.current) {
            return;
        }
        if (postData?.status && postData?.data) {
            const { signed, supervisorSigned } = resolveDocumentSignStatusesFromApi(
                postData.data
            );
            const hasFrontJson =
                postData.data.front_json != null &&
                postData.data.front_json !== '' &&
                postData.data.front_json !== 'null';

            if (hasFrontJson) {
                const frontJson = JSON.parse(postData.data.front_json);
                setStatement(postData.data.paragraph);
                setCommonData((prev) => ({
                    ...prev,
                    date_of_service: postData.data.date_of_service,
                    count: 1,
                }));
                setViewEdit((prev) => ({
                    ...prev,
                    confirmChange: postData.data.view_edit_flag ? true : false,
                    client_document_id: editId,
                    editData: frontJson,
                    diagnosis: postData.data.client_document_diagnosis ?? [],
                    editBy: postData.data.statusUpdatedUserName,
                    editTime: postData.data.statusUpdatedDateTime,
                    signed_at: postData.data.signed_at,
                    signed,
                    supervisorSigned,
                    statusSuperVisorSigned: postData.data.statusUpdatedSupervisorUserName,
                    signature: postData.data.signature,
                    supervisor_signature: postData.data.supervisor_signature,
                    supervisor_signed_at: postData.data.supervisor_signed_at,
                    status_updated_by_role: postData.data.status_updated_by_role,
                    created_by: postData.data.created_by ?? 0,
                    supervisor_signed_by: postData.data.supervisor_signed_by ?? 0,
                }));
                setSelectAllData(frontJson);
                setPayloadData((prev) => ({
                    ...(prev && typeof prev === 'object' ? prev : {}),
                    ...frontJson,
                    client_document_id: editId,
                }));
            } else {
                if (postData.data.paragraph) {
                    setStatement(postData.data.paragraph);
                }
                setCommonData((prev) => ({
                    ...prev,
                    date_of_service: postData.data.date_of_service ?? prev.date_of_service,
                    count: 1,
                }));
                setViewEdit((prev) => ({
                    ...prev,
                    confirmChange: postData.data.view_edit_flag ? true : false,
                    client_document_id: editId,
                    signed,
                    supervisorSigned,
                    created_by: postData.data.created_by ?? prev.created_by ?? 0,
                    diagnosis: postData.data.client_document_diagnosis ?? prev.diagnosis,
                    editBy: postData.data.statusUpdatedUserName ?? prev.editBy,
                    editTime: postData.data.statusUpdatedDateTime ?? prev.editTime,
                }));
            }
        }
        if (isMountedRef.current) {
            setDocumentMetaLoaded(true);
        }
    }

    //call date submit function
    const submitDatefunction = async () => {
        if (commonData.date_of_service === 'Invalid date') {
            setCommonData((prev) => ({
                ...prev,
                showError: true,
                isLoading: false,
                count: 22,
            }));
            return;
        }

        setCommonData((prev) => ({ ...prev, showError: false, isLoading: true }));

        const noteData = await postRequest('/latest-notes', { client_id: userInfo.id }, true);
        if (!noteData?.status) {
            setCommonData((prev) => ({
                ...prev,
                showError: true,
                isLoading: false,
                count: 11,
            }));
            return;
        }

        const postData = await postRequest(
            '/set-date-of-service',
            {
                client_document_id: viewEdit.client_document_id,
                date_of_service: commonData.date_of_service,
                client_id: userInfo.id,
                document_type: 'discharge_summary',
            },
            true
        );
        if (postData) {
            const session = getSession('userData') || {};
            setViewEdit((prev) => ({
                ...prev,
                client_document_id: postData.client_document_id,
                created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
            }));
            setCommonData((prev) => ({
                ...prev,
                showError: false,
                isLoading: false,
                count: 1,
            }));
        } else {
            setCommonData((prev) => ({ ...prev, isLoading: false }));
        }
    };

    //changeCommon data
    const changeCommonData = useCallback(() => {
        if (viewEdit.client_document_id === 0) {
            setCommonData((prev) => ({ ...prev, count: 2 }));
        }
    }, [viewEdit.client_document_id]);

    const pareCommonData = useMemo(
        () => ({ commonData, changeCommonData }),
        [commonData, changeCommonData]
    );

    const sessionUser = getSession('userData') || {};
    const signOffState = resolveSignOffButtonState({
        signed: viewEdit.signed,
        supervisorSigned: viewEdit.supervisorSigned,
        userRoleSlug: userInfo.user_role_slug,
        userSupervisorId: userInfo.user_supervisor_id,
        documentCreatedBy: viewEdit.created_by,
        userId: sessionUser.id,
        clientSupervisorId: userInfo.client_supervisor_id,
    });
    checkSigned = signOffState.checkSigned;
    supervisorSigned = signOffState.supervisorSigned;
    showSigned = signOffState.showSigned;
    const {
        contentEditable,
        isViewOnlyDocument,
        showDocumentEditActions,
    } = resolveDocumentEditorAccess({
        editId,
        documentMetaLoaded,
        signed: viewEdit.signed,
        supervisorSigned: viewEdit.supervisorSigned,
        userRoleSlug: userInfo.user_role_slug,
        userId: sessionUser.id,
        clientCreatorId: userInfo.creator_id,
    });
    const clinicianFinalSignOnly = isClinicianFinalSignOnly(
        viewEdit.signed,
        viewEdit.supervisorSigned,
        userInfo.user_role_slug,
        sessionUser.id,
        userInfo.creator_id,
        viewEdit.created_by
    );

    /**
     * to get latest progress note data
     */
    const getProgressNote = async () => {
        const postData = await postRequest("/latest-notes", { client_id: userInfo.id }, true);
        if (postData) {
            if (postData.status) {
                if (postData.data.notesArr && postData.data.notesArr.length > 0) {
                    const builtChildren = [];
                    for (let i in postData.data.notesArr) {
                        let tmpGoal = []
                        let tmpObjective = []
                        for (let j in postData.data.notesArr[i]) {
                            let tmpTag = document.createElement("div")
                            tmpTag.innerHTML = postData.data.notesArr[i][j]

                            if (j.includes('goal')) {
                                tmpGoal.push(returnNewElement(j, tmpTag.innerText))
                            } else if (j.includes('objective')) {
                                tmpObjective.push(returnNewElement(j, tmpTag.innerText, "checkbox", { child: dischargeSummaryCommonChild_1 }))
                            }
                        }
                        tmpGoal[0]['child'] = [dischargeSummaryCommonChild_0, tmpObjective, [dischargeSummeryDidWellWith], [dischargeSummeryStruggledWith]]
                        builtChildren.push(...tmpGoal)
                    }
                    setFormJson((prev) => {
                        const next = JSON.parse(JSON.stringify(dischargeSummeryData));
                        next[0] = { ...next[0], child: [...builtChildren, ...(next[0].child || [])] };
                        return next;
                    });
                    setViewEdit((prev) => ({
                        ...prev,
                        notes_id: postData.data.notes_id,
                    }));
                    
                }
            }
        }
    }

    const returnNewElement = (key, name, type = "checkbox", additional = "") => {
        return {
            name,
            key,
            type,
            for: "normal",
            ...additional
        }
    }

    //download
    const downloadDocument = async () => {
        let signatureText = "<div className='col-xs-12 mt-4'><hr />";

        signatureText += buildSignatureParagraphHtml(resolveDocumentSignatures({
            signed: viewEdit.signed,
            supervisor_signed: viewEdit.supervisorSigned,
            signature: viewEdit.signature,
            supervisor_signature: viewEdit.supervisor_signature,
            signed_at: viewEdit.editTime,
            supervisor_signed_at: viewEdit.supervisor_signed_at,
            status_updated_by_role: viewEdit.status_updated_by_role,
            created_by: viewEdit.created_by,
            supervisor_signed_by: viewEdit.supervisor_signed_by,
        }));
        signatureText += `</div>`;
        const postData = await postRequest("/download-client-document-pdf",
            { 
                client_document_id: viewEdit.client_document_id,
                signature: signatureText
            }, true);
        if (postData) {            
            const link = document.createElement('a');
            link.target = "_blank"
            // link.href = Url+(postData.split('/html')[1]);
            link.href = postData;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    function changeDateForService(e) {
        setCommonData((prev) => ({
            ...prev,
            date_of_service: moment(e).format('MM/DD/Y'),
        }));
        setTimeout(() => {
            $('#dischargeSummaryButton').trigger('click');
        });
    }

    const getDateOfService = () => {
        return commonData.date_of_service;
    }

    React.useEffect(() => {
        let mounted = true;

        const loadDischargeData = async () => {
            setLoading(true);
            try {
                await getProgressNote();
                if (!mounted) {
                    return;
                }
                if (editId > 0) {
                    await setEditableCheckBox();
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        loadDischargeData();

        return () => {
            mounted = false;
        };
    }, [])

    // React.useEffect(() => {
    //     if(!viewEdit.confirmChange){
    //     const scrollDiv = document.getElementsByClassName('statementComponent__div')[0];
    //     scrollDiv.scrollTo(0, scrollDiv.offsetTop*100)
    // }         
    // }, [Statement])  
    useEffect(() => {
        if (!viewEdit.confirmChange) {
          if ($(".scrollTODiv").length) {
            setTimeout(() => {
              $("#statementComponent__div_id_ds").animate({
                scrollTop:
                  $("#statementComponent__div_id_ds").scrollTop() +
                  ($(
                    '#statementComponent__div_id_ds .scrollTODiv'
                  ).offset()?.top -
                    $("#statementComponent__div_id_ds").offset()?.top),
              });
            }, 20);
          }
        }
      },[Statement])

    const isPageLoading = loading || Boolean(commonData.isLoading);
    const blockMainFormInteraction =
        isPageLoading ||
        (editId > 0 && !documentMetaLoaded) ||
        isViewOnlyDocument;

    return (
        <React.Fragment>
            <div className="row g-6 g-xl-9 note-editor-layout">
                {isViewOnlyDocument ? (
                    <div className="col-12">
                        <div className="alert alert-info mb-0">
                            This document cannot be edited.
                            {clinicianFinalSignOnly
                                ? ' Review the note below and use Sign Doc to apply your signature.'
                                : ' Use View to read the document.'}
                        </div>
                    </div>
                ) : null}
                {
                    !viewEdit.confirmChange && !isViewOnlyDocument
                        ? <>
                            <div className="col-lg-7 col-xxl-7 customUl">
                                <div className="card h-100 note-form-card">
                                    <div className="card-body p-9">
                                        <div className="col-lg-6 customUi mb-3">
                                            <div className="px-4 py-2 row">
                                                <div className="col-md-6 pr-0">
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            label="Date Of Service"
                                                            inputFormat="MM/dd/yyyy"
                                                            value={moment.utc(moment(commonData.date_of_service)).format()}
                                                            onChange={changeDateForService}
                                                            disabled={isPageLoading}
                                                            renderInput={(params) => (
                                                                <TextField {...params} disabled={isPageLoading} />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div
                                                    className={`col-md-6 startEndDiv pl-0${
                                                        isPageLoading ? ' startEndDiv--loading' : ''
                                                    }`}
                                                >
                                                    {isPageLoading ? (
                                                        <Loader
                                                            type="ThreeDots"
                                                            color="#017EAD"
                                                            height={32}
                                                            width={32}
                                                            timeout={300000}
                                                        />
                                                    ) : (
                                                        <button
                                                            className="btn btn-primary allNotes__dateOfServices__btn mx-2"
                                                            id="dischargeSummaryButton"
                                                            type="button"
                                                            onClick={submitDatefunction}
                                                            disabled={!commonData.date_of_service || isPageLoading}
                                                        >
                                                            {commonData.count === 1 ? (
                                                                <i className="fas fa-pencil-alt" />
                                                            ) : (
                                                                'Start Discharge Summary'
                                                            )}
                                                        </button>
                                                    )}
                                                </div>
                                                {commonData.count == 11 ? (
                                                    <b className="text-danger">
                                                        Please create a Treatment Plan to start Discharge Summary.
                                                    </b>
                                                ) : null}
                                                {commonData.count == 22 || commonData.count > 1 ? (
                                                    <b className="text-danger h3">Please Start Discharge Summary</b>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div
                                            className="note-form-main-section"
                                            aria-busy={blockMainFormInteraction}
                                        >
                                        {blockMainFormInteraction ? (
                                            <div
                                                className="note-form-loading-overlay"
                                                aria-hidden="true"
                                            />
                                        ) : null}
                                        <div className="d-flex flex-column fv-row mb-7">
                                            <Pare
                                                selectAllData={selectAllData}
                                                setStatement={(e) => setStatement(e)}
                                                viewEdit={viewEdit}
                                                setViewEdit={(e) => {
                                                    const session = getSession('userData') || {};
                                                    setViewEdit(prev => ({
                                                        ...prev,
                                                        client_document_id: e.client_document_id,
                                                        is_updated: e.is_updated,
                                                        created_by: resolveDocumentCreatedBy(prev.created_by, session.id),
                                                    }));
                                                }}
                                                setAllData={setData}
                                                data={formJson}
                                                URL={URL}
                                                editMode={viewEdit.editData}
                                                notes_id={viewEdit.notes_id}
                                                commonData={pareCommonData} 
                                                setpayloadsData={setPayloadData}
                                                getDateOfService={getDateOfService}
                                                setSentenceLoader={setSentenceLoader}
                                                setCheckboxLoader={setCheckboxLoader}
                                                onFrontJsonPersisted={handleFrontJsonPersisted}
                                                onFormSelectionChange={handleFormSelectionChange}
                                                />
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        : ""
                }
                <div className={`note-preview-column col-lg-${!viewEdit.confirmChange ? 5 : 12} col-xxl-${!viewEdit.confirmChange ? 5 : 12}`}>
                    <div className="card note-preview-card">
                        <div className="card-body p-9 note-preview-card-body">
                            { sentenceLoader && <div style={{
                                        position:'absolute',
                                        top:0,
                                        left:0,
                                        height:"100%",
                                        width:"100%",
                                        backdropFilter: "blur(1.5px)",
                                        zIndex: 99999,
                                        pointerEvents: 'none',
                                    }}>
                                      <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%", width:"100%",}}>
                                        <Loader
                                          type="ThreeDots"
                                          color="#017EAD"
                                          height={50}
                                          width={50}
                                          timeout={300000} />
                                      </div>
                                </div>
                            }
                            <div className="">
                                {
                                    viewEdit.confirmChange
                                        ? (viewEdit.diagnosis
                                            ? <div>
                                                <h2>Diagnosis</h2>
                                                {
                                                    viewEdit.diagnosis.map((e, i) => {
                                                        return e.diagnosis !== null
                                                            ? <div className='d-inline-block bg-grey rounded selected_diagnosis m-2' key={i + "_"}>
                                                                <div className='d-flex selected_diagnosis__div'>
                                                                    <p>{e.diagnosis.name}  </p>
                                                                </div>
                                                            </div>
                                                            : ""
                                                    }
                                                    )
                                                }
                                                <hr />
                                            </div>
                                            : "")
                                        : ""
                                }
                            </div>
                            <div className="note-preview-header cust__diagnosis_addNew_spaceBet">
                                <label className="form-label text-dark fs-6 mb-0">
                                    <span className="fw-bolder">{userInfo.full_name}</span>
                                    {Statement || viewEdit.client_document_id > 0 ? (
                                        <>
                                            <br />
                                            <span>
                                                <span className="fw-bolder">DOB:</span>{' '}
                                                {moment(userInfo.dob).format('MM/DD/Y')}
                                            </span>
                                        </>
                                    ) : null}
                                </label>
                                <div className="form-label text-dark fs-6 mb-0 note-preview-header__meta">
                                    <span className="fw-bolder">Discharge Summary</span>
                                    {(Statement || viewEdit.client_document_id > 0) && commonData.date_of_service ? (
                                        <>
                                            <br />
                                            <span>
                                                <span className="fw-bolder">Date Of Service: </span>
                                                {moment(commonData.date_of_service).format('MM/DD/Y')}
                                            </span>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                            <div
                                className={`d-flex flex-column statementComponent__div fv-row mb-7${
                                    viewEdit.confirmChange
                                        ? ' statementComponent__div--editor'
                                        : ' scroll_statement_div'
                                }`}
                                id="statementComponent__div_id_ds"
                                style={
                                    viewEdit.confirmChange
                                        ? { scrollPaddingTop: '50px' }
                                        : { maxHeight: '500px', scrollPaddingTop: '50px' }
                                }
                            >
                                {
                                    viewEdit.confirmChange
                                        ? <CKEditor
                                            editor={ClassicEditor}
                                            name="test"
                                            data={Statement}
                                            config={{ toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'] }}
                                            onChange={(event, editor) => setStatement(editor.getData())}
                                        > </CKEditor>
                                        : <div
                                            className="fs-6 text-dark form-label mb-0"
                                            style={{ fontSize: "16px" }}
                                            dangerouslySetInnerHTML={{ __html: Statement }}
                                        />
                                }
                            </div>
                            <div className="d-flex flex-wrap fv-row mb-7">
                                {
                                    Statement !== ''
                                        ? <button className="btn btn-primary btn-sm me-3 mb-3" onClick={() => { setViewEdit(prev => {
                                            return { ...prev, viewStatement: true }
                                        }) }}>View</button>
                                        : ""
                                }
                                {
                                    showDocumentEditActions
                                        ? viewEdit.confirmChange
                                            ? <button className="btn btn-info btn-sm me-3 mb-3" onClick={() => saveStatement()}>Save</button>
                                            : <button className="btn btn-info btn-sm me-3 mb-3" disabled={Statement == '' ? true : false} onClick={() => saveStatement()}>Save</button>
                                        : ""
                                }
                                {
                                    showDocumentEditActions && !viewEdit.confirmChange
                                        ? <button className="btn btn-danger btn-sm me-3 mb-3" disabled={Statement == '' ? true : false} onClick={() => setViewEdit(prev => {
                                            return { ...prev, showModal: true }
                                        })}>Manually edit</button>
                                        : ""
                                }
                                {
                                    (Statement !== '' || (showSigned == 0 || viewEdit.is_updated !== 0))
                                        ? <button className="btn btn-success btn-sm me-3 mb-3"
                                            onClick={() => setSignOff({ ...SignOff, signOff: true, supervisor_signed: supervisorSigned, signed: checkSigned })}>
                                            {getSignOffButtonLabel(checkSigned)}
                                        </button>
                                        : ""
                                }                                
                                <button className="btn btn-warning btn-sm me-3 mb-3" onClick={downloadDocument} disabled={Statement === ''}>
                                    <i className='fa fa-file-download' style={{ width: "10px" }}></i>
                                </button>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CustModal show={viewEdit.showModal} close={() => setViewEdit(prev => {
                return { ...prev, showModal: false }
            })} header="Are you sure you would like to manually edit your text now?">
                <div className="row">
                    <div className="col-xs-12">
                        <div className='h5'>
                            Are you sure you want to manually edit your document? Once you do, you will no longer have access to the keywords.
                        </div>
                    </div>
                    <div className="col-xs-12 mt-4">
                        <div className="">
                            <button className="btn btn-primary mx-2" onClick={() => setViewEdit(prev => {
                                return { ...prev, showModal: false, confirmChange: true }
                            })}>Yes, manually edit</button>
                            <button className="btn btn-danger mx-2" onClick={() => setViewEdit(prev => {
                                return { ...prev, showModal: false }
                            })}>No, return to keyword selections</button>
                        </div>
                    </div>
                </div>
            </CustModal>
            <CustModal show={SignOff.signOff} close={() => setSignOff({ ...SignOff, signOff: false })} header="Ready to sign doc?" size="sm">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>
                            Are you sure you would like to {getSignOffConfirmPrompt(checkSigned)} ?
                        </h4>
                    </div>
                    <div className="col-xs-12 mt-4">
                        <div className="">
                            <button className="btn btn-primary mx-2" onClick={() => signOffFun()}>Confirm</button>
                            <button className="btn btn-danger mx-2" onClick={() => setSignOff({ ...SignOff, signOff: false })}>Cancel</button>
                        </div>
                    </div>
                </div>
            </CustModal>

            <CustModal show={viewEdit.viewStatement} close={() => setViewEdit(prev => {
                return { ...prev, viewStatement: false }
            })} header={userInfo.full_name} size="lg" centerHeader="Discharge Summery">
                <div className="row">
                    {/* <div className="col-xs-12">
                        {
                            commonData.date_of_service
                                ? <div className='mb-2'><h4>Date Of Service</h4><label>{Moment(commonData.date_of_service).format('DD-MM-YYYY')}</label><hr /></div>
                                : ""
                        }
                        {viewEdit.diagnosis
                            ? <div>
                                <h4>Diagnosis</h4>
                                {
                                    viewEdit.diagnosis.map((e, i) => {
                                        return e.diagnosis !== null
                                            ? <div className='d-inline-block bg-grey rounded selected_diagnosis m-2' key={"_" + i}>
                                                <div className='d-flex selected_diagnosis__div'>
                                                    <p>{e.diagnosis.name}  </p>
                                                </div>
                                            </div>
                                            : ""
                                    }
                                    )
                                }
                                <hr />
                            </div>
                            : ""
                        }
                    </div> */}
                    <div className="col-xs-12">
                        <div dangerouslySetInnerHTML={{ __html: stripEmbeddedSignaturesFromHtml(Statement) }} />
                    </div>
                    {
                        (() => {
                            const signatures = resolveDocumentSignatures({
                                signed: viewEdit.signed,
                                supervisor_signed: viewEdit.supervisorSigned,
                                signature: viewEdit.signature,
                                supervisor_signature: viewEdit.supervisor_signature,
                                signed_at: viewEdit.editTime,
                                supervisor_signed_at: viewEdit.supervisor_signed_at,
                                status_updated_by_role: viewEdit.status_updated_by_role,
                                created_by: viewEdit.created_by,
                                supervisor_signed_by: viewEdit.supervisor_signed_by,
                            });
                            if (!signatures.clinician.show && !signatures.supervisor.show) {
                                return '';
                            }
                            return (
                                <div className="col-xs-12 mt-4">
                                    <hr />
                                    {signatures.clinician.show ? <p>{formatSignatureLine(signatures.clinician.text, signatures.clinician.at)}</p> : ""}
                                    {signatures.supervisor.show ? <p>{formatSignatureLine(signatures.supervisor.text, signatures.supervisor.at)}</p> : ""}
                                </div>
                            );
                        })()
                    }
                    <div className="col-xs-12 mt-4">
                        <hr />
                        <div className="">
                            <button className="btn btn-primary rounded-sm mx-2" onClick={() => setViewEdit(prev => {
                                return { ...prev, viewStatement: false }
                            })}>Ok</button>
                        </div>
                    </div>
                </div>
            </CustModal>

            <CustModal show={viewEdit.confirmSave} close={() => setViewEdit(prev => {
                return { ...prev, confirmSave: false }
            })} header="Success" size="sm">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>
                            Document is saved
                        </h4>
                    </div>
                    <div className="col-xs-12 mt-4">
                        <div className="">
                            <button className="btn btn-primary mx-2" onClick={() => changePage({ id: 6 })}>Go to Profile</button>
                            <button className="btn btn-danger mx-2" onClick={() => setViewEdit(prev => {
                                return { ...prev, confirmSave: false }
                            })}>Continue</button>
                        </div>
                    </div>
                </div>
            </CustModal>
        </React.Fragment>
    )
}

export default DischargeSummary